import _objectWithoutProperties from "/codebuild/output/src875296868/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
const _excluded = ["interactToolTip", "tooltip", "options", "title", "name", "labelPlacement", "value", "onChange", "color", "className", "radioTextExplain", "cleanToolTip", "fullWidth", "row", "boxSize"];
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
import React, { useState } from 'react';
import { Block } from '@guryou/html-components';
import { FormControlLabel, FormLabel, Radio, RadioGroup } from '@material-ui/core';
import FormControl from '@material-ui/core/FormControl';
import PropTypes from 'prop-types';
import { ToolTipHover } from '../ToolTipHover';
import '../assets/inputFields.css';
const RadioGroupBox = props => {
  const {
      interactToolTip = false,
      tooltip,
      options,
      title,
      name,
      labelPlacement,
      value,
      onChange,
      color,
      className,
      radioTextExplain,
      cleanToolTip,
      fullWidth,
      row = false,
      boxSize
    } = props,
    rest = _objectWithoutProperties(props, _excluded);
  const [localValue, setLocalValue] = useState(value);
  const onChangeHandler = e => {
    onChange && onChange(e);
    setLocalValue(e.target.value);
  };
  return /*#__PURE__*/React.createElement(FormControl, {
    fullWidth: fullWidth || false,
    className: className || '',
    component: "fieldset"
  }, /*#__PURE__*/React.createElement(FormLabel, {
    component: "legend"
  }, title), /*#__PURE__*/React.createElement(RadioGroup, _extends({
    row: row,
    "aria-label": "position"
  }, rest, {
    name: name,
    onChange: onChangeHandler,
    value: localValue
  }), options.map((x, idx) => /*#__PURE__*/React.createElement(Block, {
    key: x.name || x.label || +Date.now(),
    xs: boxSize ? boxSize : row ? 6 : 12
  }, /*#__PURE__*/React.createElement(FormControlLabel, {
    key: "".concat(x.id || x.value, "_").concat(idx),
    value: x.id || x.value,
    control: /*#__PURE__*/React.createElement(Radio, {
      color: color || 'primary'
    }),
    label: tooltip ? /*#__PURE__*/React.createElement(ToolTipHover, {
      cleanToolTip: cleanToolTip,
      interact: interactToolTip,
      fontSize: "0.90rem",
      label: x.label || x.name || x.text,
      text: x.text
    }) : x.label || x.name || x.text,
    labelPlacement: labelPlacement || 'start'
  }), radioTextExplain && /*#__PURE__*/React.createElement("p", {
    className: "gray"
  }, x.text)))));
};
RadioGroupBox.propTypes = {
  name: PropTypes.string,
  label: PropTypes.string,
  required: PropTypes.bool,
  email: PropTypes.bool,
  minLength: PropTypes.number,
  maxLength: PropTypes.number,
  disabled: PropTypes.bool,
  value: PropTypes.string,
  defaultValue: PropTypes.string,
  onChange: PropTypes.func,
  placeholder: PropTypes.string,
  options: PropTypes.array,
  color: PropTypes.string,
  title: PropTypes.string,
  labelPlacement: PropTypes.oneOf(['start', 'top', 'bottom', 'end'])
};
export default RadioGroupBox;